"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupRegistrationPresenter = exports.UserRegistrationPresenter = exports.RegistrationPresenter = void 0;
const common_1 = require("../js/common");
class RegistrationPresenter {
    viewModel;
    constructor(viewModel) {
        this.viewModel = viewModel;
    }
    nextStep() {
        this.viewModel.step++;
    }
    prevStep() {
        if (this.viewModel.step <= 1) {
            return;
        }
        this.viewModel.step--;
    }
    setIsLoading(loading) {
        this.viewModel.isLoading = loading;
    }
    toggleSelectedFeature(id) {
        const list = this.viewModel.selectedFeatures;
        const index = list.indexOf(id);
        if (index >= 0) {
            list.splice(index, 1);
        }
        else {
            list.push(id);
        }
        this.viewModel.selectedFeatures = list;
    }
}
exports.RegistrationPresenter = RegistrationPresenter;
class UserRegistrationPresenter extends RegistrationPresenter {
    user;
    constructor(viewModel, user) {
        super(viewModel);
        this.user = user;
    }
    setField(k, v) {
        this.user.form[k] = v;
    }
    validate() {
        const u = this.user.form;
        this.user.errors = {
            name: !u.name?.trim(),
            furigana: !u.furigana?.trim(),
            phone: !u.phone?.trim(),
            email: this.viewModel.branchId ? !u.email?.trim() : false,
        };
        return !Object.values(this.user.errors).some(Boolean);
    }
}
exports.UserRegistrationPresenter = UserRegistrationPresenter;
class GroupRegistrationPresenter extends RegistrationPresenter {
    user;
    group;
    constructor(viewModel, user, group) {
        super(viewModel);
        this.user = user;
        this.group = group;
    }
    setField(k, v) {
        this.group.form[k] = v;
    }
    validate() {
        const g = this.group.form;
        this.group.errors = {
            name: !g.name?.trim(),
            address: !g.address?.trim(),
            category: g.category === null,
            numOfExpectedUsers: g.numOfExpectedUsers === null,
            numOfExpectedBranches: g.numOfExpectedBranches === null,
            referrer: g.referrer === null,
        };
        return !Object.values(this.group.errors).some(Boolean);
    }
    createHubspotContact() {
        const [last, first] = (0, common_1.splitFullName)(this.user.form.name);
        const selected = this.viewModel.branchCategories.find(c => String(c.Value) === String(this.group.form.category));
        const using_the_desired_number_of_people = this.group.form.numOfExpectedUsers || 0;
        const details = {
            email: this.user.form.email || "",
            id: String(this.user.form.id || ""),
            company: this.group.form.name || "",
            firstname: first,
            lastname: last,
            phone: this.user.form.phone || "",
            using_the_desired_number_of_people,
            industry: selected?.Japanese || "未設定",
        };
        const w = window;
        w._hsq = w._hsq || [];
        w._hsq.push(["reset"]);
        w._hsq.push(["identify", details]);
        w._hsq.push(["trackPageView"]);
    }
}
exports.GroupRegistrationPresenter = GroupRegistrationPresenter;
